import React from 'react';
import '../styles/About.css';
import { FaCheckCircle, FaStar, FaAward, FaUsers } from 'react-icons/fa';

const About = () => {
  const features = [
    'Licensed & Insured',
    'Free Estimates',
    'Quality Guaranteed',
    'Experienced Team',
    'On-Time Completion',
    'Competitive Pricing'
  ];

  const stats = [
    { icon: <FaAward />, number: '15+', label: 'Years Experience' },
    { icon: <FaUsers />, number: '500+', label: 'Happy Clients' },
    { icon: <FaStar />, number: '100%', label: 'Satisfaction Rate' }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About M502 Construction LLC</h2>
            <p className="about-description">
              Based in San Marcos, Texas, M502 Construction LLC is your trusted partner 
              for all construction needs. With over 15 years of experience, we pride 
              ourselves on delivering exceptional quality and service to every project.
            </p>
            <p className="about-description">
              Our commitment to excellence, combined with our comprehensive range of 
              services, makes us the go-to choice for residential and commercial 
              construction projects throughout Central Texas.
            </p>
            
            <div className="features-list">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div className="about-owner">
              <h3>Antonio Gutiérez</h3>
              <p>Owner & Lead Contractor</p>
            </div>
          </div>

          <div className="about-visual">
            <div className="stats-container">
              {stats.map((stat, index) => (
                <div key={index} className="stat-card">
                  <div className="stat-icon">{stat.icon}</div>
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
            
            {/* NOTA: Aquí puedes agregar el logo grande o una imagen */}
            <div className="about-image-container">
              
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;